import { apiRequest } from 'platform/utilities/api';
import environment from 'platform/utilities/environment';

export const CHAMPVA_ENROLLMENT_STATUS_ACTIONS = {
  STARTED: 'FETCH_CHAMPVA_ENROLLMENT_STATUS_STARTED',
  SUCCEEDED: 'FETCH_CHAMPVA_ENROLLMENT_STATUS_SUCCEEDED',
  FAILED: 'FETCH_CHAMPVA_ENROLLMENT_STATUS_FAILED',
};

export const CHAMPVA_ENROLLMENT_STATUS_ENDPOINT = `${environment.API_URL}/ivc_champva/v1/forms/champva_enrollment_status`;

export const fetchChampvaEnrollmentStatus =
  ({ beneficiary }) =>
  async (dispatch, getState) => {
    const getSlice = () => getState().champvaEnrollmentStatus;
    if (getSlice().loading) return null;

    const { STARTED, SUCCEEDED, FAILED } = CHAMPVA_ENROLLMENT_STATUS_ACTIONS;

    dispatch({ type: STARTED });

    const response = await apiRequest(CHAMPVA_ENROLLMENT_STATUS_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ beneficiary }),
    }).catch(({ errors }) => {
      dispatch({ type: FAILED, errors });
      return null;
    });

    if (response) {
      dispatch({ type: SUCCEEDED, response: response.data ?? {} });
    }

    return getSlice();
  };
